/* Bluen combo builder: display estimates only; Shopify owns checkout pricing. */
(() => {
  if (customElements.get('bluen-combo')) return;
  class BluenCombo extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.querySelector('[data-submit]')) return;
      this.ready = true; this.picks = new Map(); this.busy = false;
      this.root = window.Shopify?.routes?.root || '/';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency', currency:this.dataset.currency || 'INR'});
      this.onClick = e => this.click(e);
      this.addEventListener('click', this.onClick);
      this.onChange = e => { if (e.target.matches('[data-variant]')) this.variant(e.target.closest('[data-product]')); };
      this.addEventListener('change', this.onChange);
      this.onFocus = () => this.refreshExisting();
      window.addEventListener('focus', this.onFocus);
      this.querySelectorAll('[data-product]').forEach(card => this.variant(card));
      this.next = this.querySelector('[data-next]')?.content.textContent.trim();
      this.q('[data-more]').hidden = !this.next;
      this.existing = this.readExisting(this);
      this.render();
      this.updateSticky = () => {
        const grid = this.q('.bc__grid').getBoundingClientRect();
        const summary = this.q('.bc__summary').getBoundingClientRect();
        const visible = summary.top < window.innerHeight && summary.bottom > 0;
        this.q('[data-sticky]').hidden = visible || grid.bottom <= 0 || grid.top >= window.innerHeight;
      };
      this.observer = new IntersectionObserver(this.updateSticky, {threshold:[0,0.01,1]});
      this.observer.observe(this.q('.bc__summary')); this.observer.observe(this.q('.bc__grid'));
      window.addEventListener('scroll',this.updateSticky,{passive:true});
      window.addEventListener('resize',this.updateSticky);
      this.updateSticky();
      this.timer = setInterval(() => this.syncCart(), 4000);
      this.syncCart();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick); this.removeEventListener('change', this.onChange);
      window.removeEventListener('focus', this.onFocus); window.removeEventListener('scroll',this.updateSticky); window.removeEventListener('resize',this.updateSticky); this.observer?.disconnect(); clearInterval(this.timer); this.ready = false;
    }
    q(s) { return this.querySelector(s); }
    cash(n) { return this.money.format(n / 100); }
    variant(card) {
      const option = card.querySelector('select').selectedOptions[0];
      if (!option) return;
      card.querySelector('[data-price]').textContent = this.cash(Number(option.dataset.price));
      const button = card.querySelector('[data-add]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Sold out' : 'Add to combo';
      const img = card.querySelector('img');
      if (img && option.dataset.image) { img.src = option.dataset.image; img.removeAttribute('srcset'); }
    }
    click(e) {
      const button = e.target.closest('button'); if (!button || !this.contains(button) || this.busy) return;
      if (button.matches('[data-add]')) {
        const card = button.closest('[data-product]'), option = card.querySelector('select').selectedOptions[0];
        if (!option || option.dataset.available !== 'true') return;
        const id = option.value, old = this.picks.get(id);
        this.picks.set(id, {id, quantity:(old?.quantity || 0)+1, price:Number(option.dataset.price), title:card.dataset.title, variant:option.textContent.trim(), image:option.dataset.image});
        this.q('[data-feedback]').textContent = ''; this.render();
      }
      if (button.dataset.adjust) {
        const item = this.picks.get(button.dataset.id); if (!item) return;
        item.quantity += Number(button.dataset.adjust);
        if (item.quantity <= 0) this.picks.delete(item.id);
        this.render();
        // Keep keyboard focus usable after rebuilding the selection list.
        const replacement = [...this.querySelectorAll('[data-adjust]')].find(b => b.dataset.id === button.dataset.id && b.dataset.adjust === button.dataset.adjust);
        (replacement || this.q('[data-clear]')).focus({preventScroll:true});
      }
      if (button.matches('[data-clear]')) { this.picks.clear(); this.render(); }
      if (button.matches('[data-review]')) this.q('.bc__summary').scrollIntoView({behavior:'smooth',block:'center'});
      if (button.matches('[data-more]')) this.more();
      if (button.matches('[data-submit]')) this.submit();
    }
    render() {
      const items = [...this.picks.values()], count = items.reduce((n,i)=>n+i.quantity,0);
      const old = this.existing || [], existing = old.reduce((n,i)=>n+i.quantity,0), eligible = count + existing;
      const all = [...old.map(i=>({...i,inCart:true})),...items];
      const subtotal = all.reduce((n,i)=>n+i.price*i.quantity,0);
      const rate = eligible >= 3 ? Number(this.dataset.rateThree) : eligible >= 2 ? Number(this.dataset.rateTwo) : 0;
      const savings = all.reduce((n,i)=>n+Math.round(i.price*i.quantity*rate/100),0);
      this.q('[data-count]').textContent = eligible;
      this.q('[data-subtotal]').textContent = this.cash(subtotal);
      this.q('[data-savings]').textContent = `−${this.cash(savings)}`;
      this.q('[data-rate]').textContent = rate ? `(${rate}%)` : '';
      this.q('[data-total]').textContent = this.cash(subtotal-savings);
      this.querySelectorAll('[data-checkpoints]').forEach(bar=>{
        bar.querySelector('[data-track-fill]').style.width = `${Math.max(0,Math.min(2,eligible-1))/2*100}%`;
        bar.querySelectorAll('[data-step]').forEach(step=>{
          const reached=eligible>=Number(step.dataset.step); step.classList.toggle('is-reached',reached);
          step.querySelector('i').textContent=reached?'✓':step.dataset.step;
        });
      });
      this.q('[data-progress]').textContent = eligible >= 3 ? `${this.dataset.rateThree}% combo tier reached.` : eligible === 2 ? `${this.dataset.rateTwo}% tier reached. Add 1 more for ${this.dataset.rateThree}%.` : `Add ${2-eligible} item${eligible === 1 ? '' : 's'} to unlock ${this.dataset.rateTwo}% off.`;
      this.q('[data-existing-note]').hidden = !existing;
      this.q('[data-existing-note]').textContent = `${existing} item${existing === 1 ? '' : 's'} already in your cart + ${count} new pick${count === 1 ? '' : 's'}. The estimate includes both. Only new picks will be added. Manage existing items in your cart.`;
      this.q('[data-submit]').disabled = eligible === 0 || this.busy;
      if (!this.busy) this.q('[data-submit]').textContent = count ? 'Add new picks to cart' : 'View cart';
      this.q('[data-clear]').disabled = !count;
      const list = this.q('[data-selected]'); list.replaceChildren();
      if (!eligible) { const p = document.createElement('p'); p.textContent = 'Your picks will appear here.'; list.append(p); }
      all.forEach(item => {
        const row = document.createElement('div'); row.className = 'bc__pick';
        if (item.image) { const img = document.createElement('img'); img.src=item.image; img.alt=''; img.width=52; img.height=60; row.append(img); }
        const info = document.createElement('div'), title = document.createElement('strong'), variant = document.createElement('small');
        title.textContent=item.title; variant.textContent=[item.variant === 'Default Title' ? '' : item.variant, item.inCart ? `Already in cart · Qty ${item.quantity}` : 'New pick'].filter(Boolean).join(' · '); info.append(title,variant);
        const controls=document.createElement('div'); controls.className='bc__quantity';
        if (!item.inCart) [-1,1].forEach(delta=> { const b=document.createElement('button'); b.type='button'; b.dataset.id=item.id; b.dataset.adjust=delta; b.textContent=delta===1?'+':'−'; b.setAttribute('aria-label',`${delta===1?'Add one':'Remove one'} ${item.title}`); controls.append(b); if(delta===-1){const n=document.createElement('span'); n.textContent=item.quantity; controls.append(n);} });
        info.append(controls); row.append(info); list.append(row);
      });
      this.renderStrip(all, eligible, rate);
    }
    readExisting(section) {
      return [...section.querySelectorAll('[data-cart-item]')].map(el=>({id:el.dataset.id,quantity:Number(el.dataset.quantity),price:Number(el.dataset.price),title:el.dataset.title,variant:el.dataset.variant,image:el.dataset.image}));
    }
    renderStrip(items,count,rate) {
      const strip=this.q('[data-sticky-picks]'); strip.replaceChildren();
      items.forEach((item,index)=>{
        if(index){const plus=document.createElement('span');plus.textContent='+';plus.className='bc__plus';strip.append(plus);}
        const tile=document.createElement('span');tile.className='bc__thumb';
        tile.title=`${item.title} · ${item.variant} · Qty ${item.quantity} · ${item.inCart?'Already in cart':'New pick'}`;
        tile.setAttribute('aria-label',tile.title);
        if(item.image){const img=document.createElement('img');img.src=item.image;img.alt='';tile.append(img);}else{tile.textContent=item.title.slice(0,2);}
        const qty=document.createElement('b');qty.textContent=item.quantity;tile.append(qty);
        if(item.inCart)tile.classList.add('is-in-cart');strip.append(tile);
      });
      if(!items.length)strip.textContent='Pick your favourites';
      this.q('[data-sticky-rate]').textContent=`= ${rate}% off`;
      this.q('[data-sticky-caption]').textContent=`${count} item${count===1?'':'s'} · ${this.q('[data-progress]').textContent}`;
    }
    async syncCart() {
      if(document.hidden || this.syncing || this.busy)return;
      this.syncing=true;
      try{
        const response=await fetch(this.root+'cart.js',{cache:'no-store',credentials:'same-origin'});
        if(!response.ok)return;
        const cart=await response.json(), fingerprint=JSON.stringify(cart.items.map(i=>[i.key,i.quantity,i.original_price]));
        if(fingerprint!==this.fingerprint){await this.refreshExisting();this.fingerprint=fingerprint;}
      }catch(_){}finally{this.syncing=false;}
    }
    async sectionHTML(url) {
      const target = new URL(url, location.origin); target.searchParams.set('section_id',this.dataset.section);
      const response = await fetch(target,{credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Could not load products. Please try again.');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const section = doc.getElementById(this.id); if (!section) throw new Error('Could not refresh this page. Please reload.');
      return section;
    }
    async refreshExisting() {
      try { const section=await this.sectionHTML(location.href); this.dataset.existing=section.dataset.existing; this.existing=this.readExisting(section); this.render(); } catch (_) { /* Estimates are labelled; checkout is authoritative. */ }
    }
    async more() {
      if (!this.next || this.loading) return; this.loading=true;
      const b=this.q('[data-more]'); b.disabled=true; b.textContent='Loading…';
      try {
        const section=await this.sectionHTML(this.next);
        section.querySelectorAll('[data-product]').forEach(card=> { if(![...this.querySelectorAll('[data-product]')].some(c=>c.dataset.product===card.dataset.product)){ this.q('.bc__grid').append(card); this.variant(card); } });
        this.next=section.querySelector('[data-next]')?.content.textContent.trim(); b.hidden=!this.next;
      } catch(error) { this.q('[data-feedback]').textContent=error.message; }
      finally { this.loading=false; b.disabled=false; b.textContent='Load more products'; }
    }
    async submit() {
      if(this.busy) return;
      if(!this.picks.size) { if(this.existing?.length) location.assign(this.root+'cart'); return; }
      this.busy=true; const b=this.q('[data-submit]'); b.disabled=true; b.textContent='Adding…';
      this.setAttribute('aria-busy','true'); this.q('[data-feedback]').textContent='';
      let added=false;
      try {
        const response=await fetch(this.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...this.picks.values()].map(i=>({id:Number(i.id),quantity:i.quantity}))})});
        const data=await response.json();
        if(!response.ok) throw new Error(typeof data.description==='string'?data.description:'Some items could not be added. Check your cart and adjust your selection.');
        added=true; this.picks.clear();
        await this.refreshExisting();
        this.q('[data-feedback]').textContent='Your combo is in the cart.';
        // Use the existing Bluen theme drawer and its existing checkout integration.
        if(window.theme?.miniCart?.generateCart && window.theme?.miniCart?.updateElements && document.querySelector('.js-mini-cart[data-cartmini="true"]')) {
          window.theme.miniCart.generateCart(); window.theme.miniCart.updateElements();
        } else { location.assign(this.root+'cart'); }
      } catch(error) {
        this.q('[data-feedback]').textContent=added?'Added to cart. Use View cart to continue.':`${error.message || 'Connection interrupted.'} Check View cart before retrying; some items may already have been added.`;
      } finally { this.busy=false; this.removeAttribute('aria-busy'); this.render(); b.textContent=this.picks.size?'Add new picks to cart':'View cart'; }
    }
  }
  customElements.define('bluen-combo',BluenCombo);
})();
